const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export function formatBRLCurrency(value?: number | string): string {
  if (value === undefined || value === null || value === '') return '';

  const numericValue = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(numericValue) ? currencyFormatter.format(numericValue) : '';
}

export function formatBRLCurrencyInput(value: string): string {
  const digits = value.replace(/\D/g, '');
  return digits ? currencyFormatter.format(Number(digits) / 100) : '';
}

export function parseBRLCurrency(value: string): number | undefined {
  const digits = value.replace(/\D/g, '');
  return digits ? Number(digits) / 100 : undefined;
}
